import React, { useEffect, useRef, useState } from 'react';
import MyLadsPresentationVideo from '../../../static/videos/splink_3.mp4';
import MyLadsHeroLoop from '../../../static/videos/splink_3.mp4';
import IconPlay from '../../../static/icons/_inline-svg/icon_play.svg';
import { PopupButton } from '@typeform/embed-react';

const HeroCard = () => {
    const heroVideo = useRef(null);
    const [videoStopped, setvideoStopped] = useState(true);
    const [videoPlaying, setvideoPlaying] = useState(false);
    const [smallScreen, setSmallScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            if (window.innerWidth < 768) {
                setSmallScreen(true);
            } else {
                setSmallScreen(false);
            }
        }

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    });

    const handlePlayVideo = () => {
        const video = document.getElementById('hero-video');
        if (smallScreen) {
            if (video.requestFullscreen) {
                video.requestFullscreen();
            } else if (video.webkitRequestFullscreen) {
                video.webkitRequestFullscreen();
            } else if (video.msRequestFullScreen) {
                video.msRequestFullScreen();
            }
        }

        setvideoPlaying(true);
        setvideoStopped(false);
        heroVideo.current.play();
    };

    const handleStopVideo = () => {
        heroVideo.current.pause();
        heroVideo.current.currentTime = 0;
        setvideoStopped(true);
    };

    const handlePauseVideo = () => {
        if (videoPlaying) {
            heroVideo.current.pause();
        } else {
            heroVideo.current.play();
        }
        setvideoPlaying(!videoPlaying);
    };

    return (
        <div className="relative p-7 pl-9 pb-10 md:pb-48 rounded-2xl">
            <button
                type="button"
                onClick={handleStopVideo}
                className={`${
                    videoStopped ? 'hidden' : ''
                } z-10 absolute top-2.5 right-2.5 bg-card-color bg-opacity-10 rounded-md p-1`}
            >
                <span className="sr-only">Stop Video</span>
                <svg
                    className="h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="var(--color-card-text)"
                    aria-hidden="true"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M6 18L18 6M6 6l12 12"
                    />
                </svg>
            </button>
            <video
                id="hero-video"
                ref={heroVideo}
                onClick={handlePauseVideo}
                onEnded={handleStopVideo}
                className={`${
                    videoStopped ? 'hidden' : ''
                } absolute top-0 left-0 w-full h-full xl:object-cover rounded-2xl`}
            >
                <source src={MyLadsPresentationVideo} type="video/mp4" />
                <track kind="captions" srcLang="en" src="" />
            </video>

            <video
                id="hero-video-loop"
                muted
                autoPlay
                loop
                className={`${
                    !videoStopped ? 'invisible' : ''
                } absolute top-0 left-0 w-full h-full object-cover rounded-2xl`}
            >
                <source src={MyLadsHeroLoop} type="video/mp4" />
                <track kind="captions" srcLang="en" src="" />
            </video>

            <div
                className={`${
                    !videoStopped ? 'invisible' : ''
                } absolute top-0 right-0 bottom-0 left-0 rounded-2xl bg-black opacity-30`}
            ></div>

            <div
                className={`relative flex ${!videoStopped ? 'invisible' : ''}`}
            >
                <div className="w-full lg:w-3/5 xl:w-1/2 1xl:w-1/3">
                    <h1 className="text-white text-50 md:text-64 font-bold mb-6">
                        So Real <br /> it feels <br /> Unreal.
                    </h1>
                    <p className="mb-10 text-white w-full sm:w-5/6">
                        FanCollex® brings your fans closer to the club through
                        Augmented Reality (AR). Visiting the stadium without
                        leaving their home or enjoying the company of a player
                        is now possible!
                    </p>

                    <div className="button-container flex flex-col md:flex-row space-y-4 md:space-x-6 md:space-y-0">
                        <div className="w-full md:w-48">
                            <PopupButton
                                id="PjrDUz5k"
                                size={65}
                                className="btn-gradient w-full h-full"
                            >
                                Start now
                            </PopupButton>
                        </div>

                        <div className="w-full md:w-48 play-video">
                            <button
                                onClick={handlePlayVideo}
                                className="btn-transparent w-full"
                            >
                                <IconPlay className="mr-3" />
                                Play video
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeroCard;
